import './simple-linear-carousel.scss';
import React, { useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import ImageGenerator from '../../image-generator/image-generator';

function SimpleLinearCarousel({ data, baseUrl }) {
	const carouselRef = useRef(null);
	const [isDragging, setIsDragging] = useState(false);
	const [startX, setStartX] = useState(0);
	const [scrollLeft, setScrollLeft] = useState(0);
	const [isMouseDown, setIsMouseDown] = useState(false);

	const handleMouseDown = (e) => {
		setStartX(e.pageX - carouselRef.current.offsetLeft);
		setScrollLeft(carouselRef.current.scrollLeft);
		setIsMouseDown(true);
		setIsDragging(false);
		carouselRef.current.style.cursor = 'grabbing';
	};

	const handleMouseMove = (e) => {
		if (!isMouseDown) return;
		const x = e.pageX - carouselRef.current.offsetLeft;
		const walk = (x - startX) * 2;
		if (Math.abs(walk) > 10) {
			setIsDragging(true);
			carouselRef.current.scrollLeft = scrollLeft - walk;
		}
	};

	const handleMouseUp = () => {
		setIsMouseDown(false);
		setIsDragging(false);
		carouselRef.current.style.cursor = 'grab';
	};

	const handleMouseLeave = () => {
		setIsMouseDown(false);
		setIsDragging(false);
		carouselRef.current.style.cursor = 'grab';
	};

	const genre_name = (genre_name) => {
		localStorage.setItem('gname', genre_name);
	};

	return (
		<div
			className="simple-linear-carousel"
			ref={carouselRef}
			onMouseDown={handleMouseDown}
			onMouseMove={handleMouseMove}
			onMouseUp={handleMouseUp}
			onMouseLeave={handleMouseLeave}
		>
			<div className="genres">
				{data.map((content, index) => (
					<Link
						key={index}
						to={content?.deepLink + `/movies`}
						className="item"
						onClick={(e) => {
							if (isDragging) {
								e.preventDefault();
							} else {
								genre_name(content.farsiTitle);
							}
						}}
						style={{
							pointerEvents: isDragging ? 'none' : 'auto'
						}}
					>
						<ImageGenerator src={content.image} name={content.title} />
						<span className="box-title">{content.farsiTitle}</span>
					</Link>
				))}
			</div>
		</div>
	);
}

export default SimpleLinearCarousel;
